import { render } from "./NavB2BLayout.vue?vue&type=template&id=1c19a55c"
import script from "./NavB2BLayout.vue?vue&type=script&lang=js"
export * from "./NavB2BLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__